import { displayDigits } from '../../utils/displayDigits';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { IoDocumentTextOutline, IoChevronForwardOutline } from 'react-icons/io5';
import { useLongPress } from '../../hooks/useLongPress';

interface Props {
  content?: string;
  title?: string;
  description?: string | null;
  onPress: () => void;
  onLongPress: () => void;
  dragProps?: {
    draggable?: boolean;
    onDragStart?: (e: React.DragEvent) => void;
    'data-dragging'?: string;
  };
}

/** Note row with long-press actions and optional desktop drag. */
export function CalendarNoteRow({ content, title, description, onPress, onLongPress, dragProps }: Props) {
  const { t } = useTranslation();
  const noteText = description ?? content ?? '';
  const { bind, wrapClick } = useLongPress(onLongPress);

  return (
    <button
      type="button"
      className={`calendar-note-row${dragProps?.['data-dragging'] === 'true' ? ' calendar-note-row--dragging' : ''}`}
      onClick={wrapClick(onPress)}
      {...bind}
      {...dragProps}
    >
      <span className="calendar-note-row__icon" aria-hidden="true"><IoDocumentTextOutline size={22} /></span>
      <span className="calendar-note-row__body">
        <span className="calendar-note-row__label">{t('calendar.noteCard.label')}</span>
        {title && <strong className="calendar-note-row__title" dir="auto">{displayDigits(title)}</strong>}
        {noteText && <span className="calendar-note-row__text" dir="auto">{displayDigits(noteText)}</span>}
      </span>
      <IoChevronForwardOutline className="calendar-note-row__chevron" size={16} aria-hidden="true" />
    </button>
  );
}
